export default __webpack_public_path__ + "static/media/box-in-logo.69326af5.svg";